import ContactForm from './ContactForm';

type Props = {
  title: string;
  subtitle: string;
  text: string;
};

export default function ContactBlock({ title, subtitle, text }: Props) {
  return (
    <section className="bg-gray-100 py-32">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-6 lg:flex-row">
        <div className="mb-16 max-w-sm lg:mr-16 lg:mb-0">
          <h1 className="text-r-sm mb-4 font-extrabold uppercase tracking-wider text-primary">
            {subtitle}
          </h1>
          <h2 className="text-r-5xl mb-8 font-bold">{title}</h2>
          <p className="text-r-lg">{text}</p>
        </div>
        <div className="w-full rounded-lg bg-white p-6 shadow-2xl md:p-12">
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
